import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { map } from 'rxjs/operators';
import { of } from 'rxjs';
@Injectable({ providedIn: 'root' })
export class AuthService {
	constructor(private http: HttpClient) {}

	login(username: string, password: string) {
		localStorage.token = 'Basic ' + btoa(`${username}:${password}`);
		// return of(true); // Bypass Login

		const httpOptions = {
			headers: new HttpHeaders({
				'Content-Type': 'application/json',
				Authorization: localStorage.token,
				'X-Requested-With': 'XMLHttpRequest',
			}),
		};
		return this.http.post(environment.apiUrl + 'cms/login', { name: username }, httpOptions).pipe(
			map((res: any) => {
				console.log(res.result.principal);
				if (res && res.result) {
					localStorage.user = JSON.stringify(res.result);
					return true;
				}
			}),
		);
	}

	getUser() {
		const user = localStorage.getItem('user');
		return user ? JSON.parse(user) : null;
	}

	getLocale() {
		const user = this.getUser();
		if (!user) {
			return 'en-US';
		}
		if (!user.cliente) {
			return 'en-US';
		}
		switch (user.cliente.nazione) {
			case 'US':
				return 'en-US';
			case 'CA':
				return 'en-US';
			case 'IT':
				return 'it-IT';
			default:
				return 'en';
		}
	}

	get isLoggedIn() {
		return this.getUser() && localStorage.token;
	}

	get isAdminOrBackoffice() {
		return this.getUser().ruolo === 'ADMIN' || this.getUser().ruolo === 'BACKOFFICE';
	}

	get isAdmin() {
		return this.getUser().ruolo === 'ADMIN';
	}

	get isPartner() {
		return this.getUser().ruolo === 'PARTNER';
	}

	get isSpedizioniere() {
		return this.getUser().ruolo === 'SPEDIZIONIERE';
	}

	get isCliente() {
		return this.getUser().ruolo === 'CLIENTE';
	}

	get isAgente() {
		return this.getUser().ruolo === 'AGENTE_INTERNO' || this.getUser().ruolo === 'AGENTE_ESTERNO';
	}

	get isAgenteInterno() {
		return this.getUser().ruolo === 'AGENTE_INTERNO';
	}
}
